/*
  The collection sub-nav is rendered inside the banner's container, so
  `position: sticky` would release it the moment that short box scrolled away.
  Swap it to fixed once it reaches the bottom of the header instead, and grow a
  sentinel in its place so the grid below does not jump up by the bar's height.
*/
(() => {
  const menus = document.querySelectorAll('.collection-menu');

  if (!menus.length) {
    return;
  }

  const headerInner = document.querySelector('.section--header .header__inner');

  menus.forEach((menu) => {
    // The sentinel stays in the flow at the menu's own place, so it is what we
    // measure against the header once the menu itself is out of the flow.
    const sentinel = document.createElement('div');
    sentinel.className = 'collection-menu__sentinel';
    menu.before(sentinel);

    // The banner is a `position: relative; z-index: 2` stacking context, so the
    // pinned bar cannot outrank the product cards from inside it on its own.
    const banner = menu.closest('.collection-banner');
    let ticking = false;

    const update = () => {
      const offset = headerInner ? headerInner.offsetHeight : 0;
      document.documentElement.style.setProperty('--collection-menu-top', `${offset}px`);

      const stuck = menu.classList.contains('collection-menu--stuck');
      const top = sentinel.getBoundingClientRect().top;

      if (!stuck && top < offset) {
        // The bar is shorter once pinned, so the gap it leaves behind has to be
        // the height it had in the flow, measured before it detaches.
        const rect = sentinel.getBoundingClientRect();

        sentinel.style.height = `${menu.offsetHeight}px`;
        // Fixed positioning is relative to the viewport, so the row has to be
        // told where its container used to hold it.
        menu.style.left = `${rect.left}px`;
        menu.style.width = `${rect.width}px`;
        menu.classList.add('collection-menu--stuck');
        banner?.classList.add('collection-banner--menu-stuck');
      } else if (stuck && top > offset) {
        menu.classList.remove('collection-menu--stuck');
        banner?.classList.remove('collection-banner--menu-stuck');
        menu.style.left = '';
        menu.style.width = '';
        sentinel.style.height = '';
      }
    };

    const onScroll = () => {
      if (ticking) {
        return;
      }

      ticking = true;

      requestAnimationFrame(() => {
        ticking = false;
        update();
      });
    };

    update();

    window.addEventListener('scroll', onScroll, { passive: true });

    // The height the bar has in the flow cannot be measured while it is fixed,
    // so a resize — a phone rotating, mostly — releases it first and lets the
    // next update pin it again against fresh measurements.
    window.addEventListener('resize', () => {
      menu.classList.remove('collection-menu--stuck');
      banner?.classList.remove('collection-banner--menu-stuck');
      menu.style.left = '';
      menu.style.width = '';
      sentinel.style.height = '';
      update();
    });
  });
})();
